import { Line, LineChart, Tooltip, XAxis } from "recharts";
import PropTypes from "prop-types";

import { selectDarkMode } from "../../state/selectors";
import { getState } from "../../state/store";

import { alignItems, colors, metricsColors, strCode } from "../../consts";
import { t } from "../../services";
import { withSection } from "../../hoc";
import { useChartData, useHideTooltip } from "../../hooks";

import {
  Heading6,
  FlexContainers,
  WrapperContainer,
  Paragraph2,
  GradientLoader
} from "../../components";
import ChartTooltip from "./components/ChartTooltip";

const DashboardNumberChart = ({ id, value, data, isLoading, isError, metricsConfig }) => {
  const darkMode = selectDarkMode()(getState());
  const { formattedData } = useChartData({ data, metricsConfig });
  const { isTooltipHidden, handleMouseLeave, handleMouseEnter } = useHideTooltip()

  return (
    <WrapperContainer Container={FlexContainers.FlexRowStart} width="100%">
      {isLoading ? (
        <GradientLoader width={"100%"} height={32} />
      ) : isError ? (
        <WrapperContainer
          Container={FlexContainers.FlexColumnCenter}
          alignItems={alignItems.start}
          width="100%">
          <Paragraph2>{t(strCode.DASHBOARD_FETCH_ERROR)}</Paragraph2>
        </WrapperContainer>
      ) : value ? (
        <>
          <Heading6>{value}</Heading6>

          {formattedData && formattedData[0] && (
            <WrapperContainer
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              ml={32} mb={-8} data-testid="simple-line-chart">
              <LineChart
                width={180}
                height={40}
                data={formattedData}
                margin={{ top: 0, bottom: -16 }}>
                <Line
                  type="linear"
                  dataKey={Object.keys(data[0]?.metrics)[0]}
                  dot={false}
                  stroke={metricsColors.BLUE}
                  animationDuration={400}
                />

                <XAxis
                  dataKey={Object.keys(formattedData[0])[0]}
                  stroke={`${darkMode ? colors.WHITE : colors.RAISIN_100}`}
                  tick={false}
                  axisLine={{ stroke: "rgba(174, 172, 177, 0.5)" }}
                  tickLine={{ stroke: "rgba(174, 172, 177, 0.5)" }}
                />

                <Tooltip
                  wrapperStyle={{ display: isTooltipHidden ? 'none' : 'block' }}
                  content={<ChartTooltip metricsConfig={metricsConfig} id={id} />}
                  cursor={{ stroke: "rgba(174, 172, 177, 0.5)", opacity: 1 }}
                />
              </LineChart>
            </WrapperContainer>
          )}
        </>
      ) : (
        <WrapperContainer
          Container={FlexContainers.FlexColumnCenter}
          alignItems={alignItems.start}
          width="100%">
          <Paragraph2>{t(strCode.NO_DATA_FOR_CHART)}</Paragraph2>
        </WrapperContainer>
      )}
    </WrapperContainer>
  );
};

DashboardNumberChart.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.number)),
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  metricsConfig: PropTypes.shape(PropTypes.object),
  id: PropTypes.string
};
export default withSection(DashboardNumberChart);
